export const DEFAULT_LOCALE = 'en-US'
export const LOCALE = process.env.LOCALE || DEFAULT_LOCALE
